/**
 * 管理画面の表示言語 (日本語 / English) — 公開 API (admin-english-toggle-20260924 / ADR-081)。
 *
 * 使い方:
 *   import { tasksNs } from '@/i18n/namespaces/tasks';
 *   const t = useT(tasksNs);          // 名前空間の handle を渡す
 *   t('page.title');                  // → 'タスク管理' / 'Tasks'
 *   t('footer.count', { count: 3 });  // 文言の {count} に差し込む
 *
 * 文言・名前空間の追加は `dictionaries.ts` の説明を参照。**画面の名前空間の handle は
 * このファイルから export しない** (export すると辞書が main chunk に入る)。この公開 API は
 * phase 2 の foundation で確定し、各 slice は編集しない。
 */
export {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  isLocale,
  type DictionaryTree,
  type HandleDictionary,
  type HandleKey,
  type HandleParamsArgs,
  type LeafKey,
  type Locale,
  type MessageAt,
  type NamespaceHandle,
  type ParamsArgs,
  type PlaceholderNames,
  type PlainHandleKey,
  type TranslationOf,
  type TranslationParams,
} from './types';
export { commonNs, shellNs } from './dictionaries';
export { defineNamespace, type DefineNamespaceOptions } from './registry';
export {
  createT,
  interpolate,
  lookupMessage,
  translate,
  translateWith,
  type HandleTFunction,
} from './translate';
export {
  LocaleProvider,
  useLocale,
  useT,
  type LocaleContextValue,
  type LocaleProviderProps,
  type SetLocaleOptions,
  type TFunction,
} from './LocaleProvider';
export {
  LOCALE_STORAGE_KEY_PREFIX,
  localeStorageKey,
  readStoredLocale,
  writeStoredLocale,
} from './localeStorage';
export { translateKnownMessage } from './knownMessages';
export {
  localizedCaseStatusLabel,
  localizedCaseTitle,
  localizedCaseTypeLabel,
  localizedCaseTypeTitle,
  localizedProgressStatusLabel,
  useCaseLabels,
} from './enumLabels';

/** 言語名 (切替ボタン・選択肢に使う)。**その言語自身の表記**で出す (どちらの言語で表示中でも読める)。 */
export const LOCALE_NATIVE_NAMES = { ja: '日本語', en: 'English' } as const;
